import { string } from '@amcharts/amcharts4/core';
import { Injectable, Inject, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ContactInfoModel } from '../models/contactInfoModel';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DirectoryModel } from '../models/directoryModel';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedObject } from '../sharedObject';
import { Store } from '@ngrx/store';

import { AppState } from './../../../../core/reducers';
import { DatePipe } from '@angular/common';

const GET_CONTACT_INFO = 'Auth/accounts/contactinfo';
const GET_DIRECTORY = 'https://sheedo.ir/api/AdWeb/GetDirectoriesByParentId?parentId=';
const GET_DIRECTORY_BY_ID = 'https://sheedo.ir/api/AdWeb/GetDirectoryById';
const ISVALID_EMAIL = 'Auth/accounts/IsValidEmail?email=';
const CHECK_USER_NAME = 'Auth/accounts/CheckUserName';
const CHECK_PHONE_NUMBER = 'Auth/Reseller/checkphonenumber';

@Injectable({
  providedIn: 'root'
})

export class CommonService implements OnInit {

  constructor(private clipboardService: ClipboardService,
    public snackBar: MatSnackBar, private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private http: HttpClient,
    //private auth: AuthService,
    public datepipe: DatePipe,
    private store: Store<AppState>,
  ) {

  }


  ngOnInit() {
  }

  getApiEndpoint() {
    // return 'http://localhost:62758/';
    //return 'http://localhost:8080/'; //My IIS
    // return"https://api.wintest.sheed.net/"
     return 'https://apiserverdev.sheedsoft.com';
    // return 'https://apiservertest.sheedsoft.com/';
    //return 'https://authapi.sheed.net/';
    // const settings = require('../../../../../assets/apiconfig.json');
    // let production = settings['production'] as boolean;
    // if (production) {
    //   return settings['apiEndpoint'];
    // } else
    //   return settings['apiEndpoint-test'];


    // return SharedObject.ApiEndpoint;
  }

  public copyText(text: string) {
    if (text == null) return;
    this.clipboardService.copyFromContent(text);
    this.snackBar.open("با موفقیت کپی شد", null, {
      duration: 2000,
    });
  }


  getContactInfo() {
    return this.http.get<ContactInfoModel>(
      `${this.getApiEndpoint()}/${GET_CONTACT_INFO}`
    ).pipe(map(res => res['result'] as ContactInfoModel));
  }


  getDirectoryModel(parentId: number = null) {
    return this.http.get<DirectoryModel[]>(
      `${GET_DIRECTORY}${parentId}`).pipe(map(res => res as DirectoryModel[]));
  }
  getDirectoryById(directoryId) {
    return this.http.get<any>(
      `${GET_DIRECTORY_BY_ID}/${directoryId}`).pipe(map(res => res as any));
  }


  showToast(msg: string) {
    this.snackBar.open(msg, null, {
      duration: 2000,
    });
  }

  isValidEmail(email: string) {
    return this.http.get(
      `${this.getApiEndpoint()}/${ISVALID_EMAIL}${email}`)
      .pipe(map(res => res['result'] as boolean));
  }
  checkUserName(userName: string) {
    let reqHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(`${this.getApiEndpoint()}/${CHECK_USER_NAME}`, JSON.stringify(userName), { headers: reqHeaders })
      .pipe(map(res => res['result']['status'] as boolean));

  }

  checkPhoneNumber(userName: string) {
    let reqHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(`${this.getApiEndpoint()}/${CHECK_PHONE_NUMBER}`, JSON.stringify(userName), { headers: reqHeaders })
      .pipe(map(res => res['result']['status'] as boolean));

  }


  getFileExtension(file: File) {
    if (file == null) return null;
    return file.name.split('.').pop();
  }

  checkImageExtension(fileName: string) {
    var ext = fileName.split('.').pop();
    if (!ext) return false;
    ext = ext.toLowerCase();
    if (ext == 'jpg') return true;
    if (ext == 'jpeg') return true;
    if (ext == 'png') return true;
    return false;
  }

  ValidationImagefile(file: File): Promise<boolean> {
    var valid = false;
    return new Promise((resolve, reject) => {
      var fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        var arr = (new Uint8Array(<ArrayBuffer>fileReader.result)).subarray(0, 4);
        var header = "";
        for (var i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }
        switch (header) {
          case "89504e47"://image/png
            resolve(true);
          case "47494638"://image/gif
            resolve(false);
          case "ffd8ffe0"://image/jpeg,jpg
          case "ffd8ffe1":
          case "ffd8ffe2":
          case "ffd8ffe3":
          case "ffd8ffe8"://image/jpeg
            resolve(true);
          default://unknown
            resolve(false);
        }

      }
      fileReader.readAsArrayBuffer(file);
    });

  }


  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  GetEndOfDay(date: Date): string {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    var dateByFomat = this.datepipe.transform(result, 'MM/dd/yyyy HH:mm:ss.sss');
    return dateByFomat;
  }

  GetStartOfDay(date: Date): string {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    var dateByFomat = this.datepipe.transform(result, 'MM/dd/yyyy HH:mm:ss.sss');
    return dateByFomat;
  }

  isValidRegex(regex: string, value: string) {
    if (new RegExp(regex).test(value)) {
      return true;
    }
    return false;
  }
  IsValidPhoneNumber(phoneNumber: string) {
    return this.isValidRegex(SharedObject.MobilePattern, phoneNumber);
  }

  showBrowserNotifiation(title, body) {
    Notification.requestPermission().then
      (function (permission) {
        var notification = new Notification(title, { body: body, icon: './assets/images/logo/sheed-logo-xs.png', dir: 'auto' });
        notification.onclick = () => {
          notification.close();
        };
      });
  }

  // reloadUser() {
  //   this.auth.getUserByToken().subscribe(res => {
  //     if (res) {
  //       const _user: User = new User();
  //       _user.firstName = res["result"]["firstName"];
  //       _user.lastName = res["result"]["lastName"];
  //       _user.isMale = res["result"]["isMale"];
  //       _user.username = res["result"]["username"];
  //       _user.role = res["result"]["role"];
  //       _user.userStatus = res["result"]["userStatus"];
  //       _user.isBeta = res["result"]["isBeta"];
  //       _user.walletBalance = res["result"]["walletBalance"];
  //       this.store.dispatch(new UserLoaded({ user: _user }));
  //     }
  //   });
  // }

  addDays(date: Date, days: number): Date {
    date = new Date(date);
    date.setDate(date.getDate() + days);
    return date;
  }

  subDays(date: Date, days: number): Date {
    date = new Date(date);
    date.setDate(date.getDate() - days);
    return date;
  }

  getPackageType(id: number) {
    switch (id) {
      case 0:
        return 'جدید';
      case 1:
        return 'تبدیل قدیمی';
      case 2:
        return 'هدیه معرفی';
      case 3:
        return 'هدیه پشتیبانی';
      case 4:
        return 'هدیه تولد';
      case 5:
        return 'تمدیدی';
      case 6:
        return 'هدیه معرفی از تلگرام';
      case 7:
        return 'تمدیدی';
      case 8:
        return 'هدیه پس از خرید';
      case 9:
        return 'خرید عمده';
      case 10:
        return 'سی دی';
      case 11:
        return 'سفارشی';
      case 12:
        return 'آزمایشی';
      case 13:
        return 'آزمایشی';
      case 14:
        return 'تبدیل';
      case 15:
        return 'هدیه';
      case 19:
        return 'کارت';
      case 20:
        return 'هدیه تکمیل پروفایل موبایل';
      default:
        return 'نامشخص';
    }
  }



  loadGoftino() {
    var g = document.createElement("script");
    g.async = true;
    var localStorageValue = localStorage.getItem("goftino_xyA2N4");
    var url = "https://www.goftino.com/widget/xyA2N4";
    if (localStorageValue) {
      g.src = url + "?o=" + localStorageValue;
    } else {
      g.src = url
    }
    document.getElementsByTagName("head")[0].appendChild(g);

  }

  // loadGTM() {


  //   var f = document.getElementsByTagName('script')[0],
  //     j = document.createElement('script'),
  //     dl = 'dataLayer';
  //   j.async = true;
  //   j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-TL67SZBV';
  //   f.parentNode.insertBefore(j, f);
  // }
}
